import { render } from "./index.vue?vue&type=template&id=38c905f5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=38c905f5&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=38c905f5&lang=scss"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c905f5"]])

export default __exports__